export default (config) => (value) => {
  const exp = /^\$?\d{1,3}(\d+(?!,))?(,\d{3})*(\.\d{2})?$/;
  return exp.test(value) ? null : config.message;
};
